module.exports = __webpack_public_path__ + "static/img/21.9d19156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/21.png
// module id = xaiA
// module chunks = 0